module.exports = {"150581001":"珠斯花街道","150581002":"莫斯台街道","150581003":"宝日呼吉尔街道","150581004":"沙尔呼热街道","150581200":"达来胡硕苏木","150581400":"东蒙鑫农牧业有限责任公司"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150581.json
// module id = 389
// module chunks = 0